import axios from 'axios'
import { BASE_URL, BASE_VIREED } from './base-url'
import VideoService from './video.service.js'

var base = BASE_URL;
var base_vireed = BASE_VIREED;


export default class ProjectService {

    createProject_old(token, project, file) {

        return new Promise((done, reject) => {

            var Vservice = new VideoService();
            Vservice.postVideo(file, token)
                .then(videoUp => {
                    project.uuid = videoUp.uuid;

                    project = JSON.stringify(project);

                    var instance = {
                        baseURL: base + '/api/projects',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Basic ' + token
                        },
                        data: project
                    };
                    axios(instance).then((response) => {
                        done(response.data);
                    }).catch((error) => {
                        reject(error);
                    })
                })
                .catch((err) => {
                    reject(err);
                });
        });

    }


    createProject(token, project, videoUUID) {

        return new Promise((done, reject) => {

            project.uuid = videoUUID;

            project = JSON.stringify(project);

            var instance = {
                baseURL: base + '/api/projects',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: project
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });

    }

    putProjectById(token, project, projectId) {
        return new Promise((done, reject) => {


            project = JSON.stringify(project);

            var instance = {
                baseURL: base + '/api/projects/' + projectId,
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: project
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    createProjectSelect(token, project, uuidVideo) {

        return new Promise((done, reject) => {

            project.uuid = uuidVideo;

            project = JSON.stringify(project);

            var instance = {
                baseURL: base + '/api/projects',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: project
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    createVersionUpload(token, projectId, videoUUID, author, description) {

        if (this.canManageVersion(token, projectId)) {
            return new Promise((done, reject) => {
                this.getProject(token, projectId)
                    .then((project) => {
                        var newVersionNumber = project.currentVersion + 1;
                        let version = {
                            createdDate: new Date(),
                            number: newVersionNumber,
                            publisher: author,
                            description: description,
                            uuidVideo: videoUUID,
                        }
                        version = JSON.stringify(version);

                        var instance = {
                            baseURL: base + '/api/projects/' + projectId + '/newversion',
                            method: 'put',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Basic ' + token
                            },
                            data: version
                        };
                        axios(instance).then((response) => {
                            done(response.data);
                        }).catch((error) => {
                            reject(error);
                        })

                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
        else {
            console.error("You can not create new version");
        }

    }

    createVersionSelection(token, projectId, uuidVideo, description, author) {

        if (this.canManageVersion(token, projectId)) {
            return new Promise((done, reject) => {
                this.getProject(token, projectId)
                    .then((project) => {
                        var newVersionNumber = project.currentVersion + 1;
                        let version = {
                            createdDate: new Date(),
                            number: newVersionNumber,
                            description: description,
                            publisher: author,
                            uuidVideo: uuidVideo,
                        }
                        version = JSON.stringify(version);

                        var instance = {
                            baseURL: base + '/api/projects/' + projectId + '/newversion',
                            method: 'put',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Basic ' + token
                            },
                            data: version
                        };
                        axios(instance).then((response) => {
                            done(response.data);
                        }).catch((error) => {
                            reject(error);
                        })

                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
        else {
            console.error("You can not create new version");
        }

    }

    getProjects(token, params = {}) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/projects',
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                params: params,
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getProjectsFromTeam(token, teamId) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/projects/team/' + teamId,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
                //params: params
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getSharedProjects(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/projects/shared',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
                //params: params
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getProject(token, projectId) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/projects/' + projectId,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getThumbnailProject(token, videoUUID) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/videos/' + videoUUID + "/thumbnail",
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
                //params: params
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getUsersOfProject(token, projectId) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/projects/' + projectId + "/users",
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    addCollaborator(token, projectId, collabUserName, collabRole) {

        let collab = {
            username: collabUserName,
            role: collabRole
        }
        let dataToSend = JSON.stringify(collab);

        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/projects/' + projectId + "/invite",
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: dataToSend,
            };
            axios(instance).then((response) => {
                done(response);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    removeCollaborator(token, projectId, collabUserName) {

        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/projects/' + projectId + "/removecollaborator/" + collabUserName,
                method: 'delete',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getVersionsList(token, projectId) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/projects/' + projectId + "/versions",
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getLastestVersion(token, projectId) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/projects/' + projectId + "/versions/lastest/",
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    canManageVersion(token, projectId) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/projects/' + projectId + "/canmanageversion",
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token,
                },
            };
            axios(instance).then((response) => {
                done(response);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    deleteVersion(token, projectId, versionNumber) {
        return new Promise((done, reject) => {

            //Suppression des annotations
            var instance = {
                baseURL: base_vireed + '/deleteVersion/' + projectId + '/' + versionNumber,
                method: 'delete',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: { token }
            };

            axios(instance).then((response) => {
                done(response.data)
                /**axios(instance2).then((response2)=>{
                   done(response.data); 
                }).catch((error) => {
                 reject(error);
             })*/
            }).catch((error) => {
                reject(error);
            })
        });
    }

    updateRoleUser(token, projectId, username, newRole) {
        return new Promise((done, reject) => {

            var dataToSend = JSON.stringify({ newRole: newRole });
            //Suppression des annotations
            var instance = {
                baseURL: base + '/api/projects/' + projectId + "/collabs/" + username + "/updateRole",
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: dataToSend,
                body: dataToSend
            };

            axios(instance).then((response) => {
                done(response)
            }).catch((error) => {
                console.log(error)
                reject(error);
            })
        });
    }

    addTeam(token, projectId, teamId) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/projects/' + projectId + "/teams/" + teamId,
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    removeTeam(token, teamId, projectId) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/projects/' + projectId + "/teams/" + teamId,
                method: 'delete',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    deleteProject(token, projectId) {
        //On fait une requête vers le serveur Vireed pour supprimer le projet
        var dataToSend = { token: token };
        dataToSend = JSON.stringify(dataToSend);
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base_vireed + "/delete/" + projectId,
                method: 'delete',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: dataToSend,
            };
            axios(instance).then((response) => {

                done(response);
            }).catch((error) => {
                reject(error);
            })
        });

    }

    getAnnotationProjectVersion = function (projectId, projectVersion) {

        return new Promise((done, reject) => {
            var instance = {
                baseURL: base_vireed + "/annotations/" + projectId + "/" + projectVersion,
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            axios(instance).then((response) => {
                done(response);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    updateProject = function (token, projectId, body)
    {
        return new Promise((done, reject) => {

            var dataToSend = JSON.stringify(body);
            //Suppression des annotations
            var instance = {
                baseURL: base + '/api/projects/' + projectId,
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: body
            };

            axios(instance).then((response) => {
                done(response)
            }).catch((error) => {
                console.log(error)
                reject(error);
            })
        });
    }

    getVersionFromVideo = function (token, videoId)
    {
        return new Promise((done, reject) => {

            var instance = {
                baseURL: base + '/api/projects/fromVideo/' + videoId,
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
            };

            axios(instance).then((response) => {
                done(response.data)
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getVideoFromProjectVerion = function(token, videoId, projectId)
    {
        return new Promise((done, reject) => {

            var instance = {
                baseURL: base + '/api/videoProjects/'+projectId + '/' + videoId,
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
            };

            axios(instance).then((response) => {
                done(response.data)
            }).catch((error) => {
                reject(error);
            })
        });
    }

    updateVersion = function (token, projectId, version, body)
    {
        return new Promise((done, reject) => {

            var dataToSend = JSON.stringify(body);
            //Suppression des annotations
            var instance = {
                baseURL: base + `/api/versions/${projectId}/${version}` ,
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: dataToSend
            };

            axios(instance).then((response) => {
                done(response)
            }).catch((error) => {
                reject(error);
            })
        });
    }

}